import { useField } from "formik";
import { useCallback, useState } from "react";

import { useFieldError, useUpdateEffect } from "@/hooks";

import { Select } from "@/components/ui/Select";
import { ValidationMessage } from "../ValidationMessage";

const FormSelect = (props) => {
  const { name, options, handleSelectChange, ...rest } = props;

  const [, meta, helpers] = useField(name);
  const hasError = useFieldError(name);

  const [currentValue, setCurrentValue] = useState(
    meta.value || meta.initialValue || ""
  );

  useUpdateEffect(() => {
    setCurrentValue(meta.value);
  }, [meta.value]);

  const handleChange = useCallback(
    (event) => {
      const value = event.target.value;

      setCurrentValue(value);
      helpers.setValue(value);
      helpers.setError("");

      if (handleSelectChange) handleSelectChange(value);
    },
    [helpers, handleSelectChange]
  );

  const handleBlur = useCallback(() => {
    helpers.setTouched(true);
  }, [helpers]);

  return (
    <div className="flex flex-col">
      <Select
        {...rest}
        options={options}
        value={currentValue}
        hasError={hasError}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <ValidationMessage name={name} />
    </div>
  );
};

export { FormSelect };
